import { baseDefaultContextProps } from '../../constants/props';
import { routes } from '../../constants/routes';
import { associateObject, fetchAssociationSectionList, removeAssociationObject, updateAssociationObject } from '../../data/api/associationsApi';
import { getAvatars } from '../../data/api/avatarsApi';
import { createCrmObjectBatch, createObject, getObject, searchObject } from '../../data/api/crmV3Api';
import { fetchPlaybooks, fetchRecommendedPlaybooks } from '../../data/api/playbooksApi';
import { calculatePropertiesRequest, fetchCardProperties, fetchExternalOptions, fetchObjectCreationFields, fetchPropertiesDetails, getCreatorAssociationPropertiesDefinitions, getDealAmountSettings, getMultiCurrencies, validateProperty } from '../../data/api/propertiesApi';
import { fetchRenderedContent, fetchUnrenderedContent, searchSnippets } from '../../data/api/snippetsApi';
export const defaultAssociationsContextProps = Object.assign({}, baseDefaultContextProps, {
  hubspotUserId: undefined,
  apiWrapper: {
    snippets: {
      fetchRenderedContent,
      fetchUnrenderedContent,
      searchSnippets
    },
    playbooks: {
      fetchPlaybooks,
      fetchRecommendedPlaybooks
    },
    getObject,
    updateAssociationObject,
    calculateProperties: calculatePropertiesRequest,
    getMultiCurrencies,
    getDealAmountSettings,
    fetchObjectCreationFields,
    fetchPropertiesDetails,
    createCrmObject: createObject,
    createCrmObjectBatch,
    validateProperty,
    getCreatorAssociationPropertiesDefinitions,
    fetchExternalOptions,
    searchObject,
    fetchAssociationSectionList,
    associateObject,
    removeAssociationObject,
    fetchCardProperties,
    getAvatars
  },
  isContactsPage: false,
  createObjectCallback: undefined,
  callObjectTitle: '',
  initMethod: () => undefined,
  // configureSdk in case Zoom App
  hasLegacyDealAmountCalculation: false,
  featureTipsLink: '',
  prosemirrorTrackerProperties: undefined,
  reconnectRoute: routes.reconnect
});